import React, { useState, useRef, useEffect } from 'react';
import BarraPrincipal from '../Modulos/BarraPrincipal';
import Swal from 'sweetalert2';
import SwitchButton2 from '../componentes/SwithButton2';
import axios from '../utils/axiosConfig';
import SwitchButton3 from '../componentes/SwitchButton3';
import { Input } from 'reactstrap';
import './Css/crearContrato3.css';


const CrearContrato3 = ({ onClose }) => {
    const [pedido, setPedido] = useState('');
    const [dispositivos, setDispositivos] = useState([]);
    const [filteredDispositivos, setFilteredDispositivos] = useState([]);
    const [tipoServicios, setTipoServicios] = useState([]);
    const [selectedDispositivos, setSelectedDispositivos] = useState([]);
    const [rutas, setRutas] = useState([]);
    const [ubicacion, setUbicacion] = useState('');
    const [Referencia, setReferencia] = useState('');
    const [contenedor, setContenedor] = useState('');
    const [placa, setPlaca] = useState('');
    const [selectedRuta, setSelectedRuta] = useState('');
    const [fechaHoraInicio, setFechaHoraInicio] = useState('');
    const [selectedTipoServicio, setSelectedTipoServicio] = useState();
    const [loading, setLoading] = useState(false);

    const handleSwitchChange = (dispositivo, isActive) => {
        if (isActive && !selectedDispositivos.includes(dispositivo) && selectedDispositivos.length >= 5) {
            Swal.fire({
                icon: 'error',
                title: 'Límite alcanzado',
                text: 'No puedes seleccionar más de 5 dispositivos.',
            });
            return;
        }

        setSelectedDispositivos((prev) =>
            isActive
                ? [...prev, dispositivo] // Agrega el dispositivo si está activo
                : prev.filter((item) => item !== dispositivo) // Elimina el dispositivo si no está activo
        );
    };

    // Deshabilitar switches adicionales
    const isDisabled = selectedDispositivos.length >= 5;


    const handleChange = (e) => {
        const selectedId = e.target.value; // Obtén el valor seleccionado (que sería el ID)
        // console.log('ID seleccionado:', selectedId);
        setSelectedTipoServicio(parseInt(selectedId)); // Actualiza el estado con el ID
        getDispositivosByTipoServicio(selectedId);
    };

    const handleChangeRuta = (e) => {
        const selectedId = e.target.value;
        setSelectedRuta(parseInt(selectedId));
    };

    const formatContenedoresToString = (dispositivos) => {
        if (!dispositivos || dispositivos.length === 0) return '';
        return dispositivos.join(','); // Une los elementos del array con comas
    };

    const cleanFields = () => {
        setPedido('');
        setDispositivos([]);
        setTipoServicios([]);
        setSelectedDispositivos([]);
        setUbicacion('');
        setFechaHoraInicio('');
        setSelectedTipoServicio();
        setReferencia('');
        setContenedor('');
        setPlaca('');
        setSelectedRuta('');
    };


    const [dates, setDates] = useState({ fechaHoraCita: '' });

    const refs = {
        fechaHoraCita: useRef(null),
    };

    const onSubmit = async (data) => {
        // console.log('Data a enviar:', data);
        await axios
            .post(process.env.REACT_APP_SERVER + "/contratos/crearcontratomovil", JSON.stringify(data), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success == false) {
                    // console.log(res);
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: `${res.data.message}`,
                        didOpen: () => {
                            const confirmButton = Swal.getConfirmButton();
                            confirmButton.style.backgroundColor = '#ff0000';
                            confirmButton.style.color = '#ffffff';
                            confirmButton.style.border = 'none';
                            confirmButton.style.padding = '10px 20px';
                            confirmButton.style.fontSize = '16px';
                            confirmButton.style.borderRadius = '5px';
                            confirmButton.style.cursor = 'pointer';
                        }
                    });
                } else {
                    cleanFields();
                    Swal.fire({
                        icon: "success",
                        title: "Contrato creado con éxito",
                        text: "Contrato cargado con éxito",
                        didOpen: () => {
                            const confirmButton = Swal.getConfirmButton();
                            confirmButton.style.backgroundColor = '#006699';
                            confirmButton.style.color = '#ffffff';
                            confirmButton.style.border = 'none';
                            confirmButton.style.padding = '10px 20px';
                            confirmButton.style.fontSize = '16px';
                            confirmButton.style.borderRadius = '5px';
                            confirmButton.style.cursor = 'pointer';
                        }
                    });

                }
            }).catch((err) => {
                console.error(err);
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Error al crear el contrato",
                    didOpen: () => {
                        const confirmButton = Swal.getConfirmButton();
                        confirmButton.style.backgroundColor = '#ff0000';
                        confirmButton.style.color = '#ffffff';
                        confirmButton.style.border = 'none';
                        confirmButton.style.padding = '10px 20px';
                        confirmButton.style.fontSize = '16px';
                        confirmButton.style.borderRadius = '5px';
                        confirmButton.style.cursor = 'pointer';
                    }
                });
            });
    };

    const handleDispositivosOnList = (e) => {
        const searchTerm = e.target.value.toLowerCase(); // Obtén el valor del input y conviértelo a minúsculas
        const filteredDispositivos = dispositivos.filter((dispositivo) =>
            dispositivo.DeviceID.toString().toLowerCase().includes(searchTerm) // Filtra los dispositivos que coinciden con el término de búsqueda
        );
        setFilteredDispositivos(filteredDispositivos);
    }

    const handleGuardar = async () => {
        if (!selectedTipoServicio || selectedDispositivos.length === 0 || !placa || !contenedor || !selectedRuta) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Todos los campos deben estar llenos.',
            });
            return;
        }

        setLoading(true);
        const format = formatContenedoresToString(selectedDispositivos);
        let data = {
            tipoequipo: selectedTipoServicio,
            Placa: placa,
            Ref: Referencia,
            Contenedor: contenedor,
            Ruta: selectedRuta,
            Listaequipo: format,
        };
        // console.log('Data:', data);
        await onSubmit(data);
        setLoading(false);
    };

    const getTypeServices = async () => {
        try {
            const res = await axios.get(process.env.REACT_APP_SERVER + "/contratos/getlistatiposequipo", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,

            });

            if (res.data.success) {
                // console.log('Tipo de servicios:', res.data.data);
                setTipoServicios(res.data.data);
            } else {
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo obtener la información, error de conexión',
                    icon: 'error',
                    showConfirmButton: true,
                });
            }
        } catch (error) {
            console.error('Error al obtener tipos de servicios:', error);
            Swal.fire({
                title: 'Error',
                text: `Error: ${error.message}`,
                icon: 'error',
                showConfirmButton: true,
            });
        }
    }

    const getRutas = async () => {
        try {
            const res = await axios.get(process.env.REACT_APP_SERVER + "/maestros/getrutas", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,

            });

            if (res.data.success) {
                // console.log('Tipo de servicios:', res.data.data);
                console.log('Rutas:', res.data.data);
                setRutas(res.data.data);
            } else {
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo obtener la información, error de conexión',
                    icon: 'error',
                    showConfirmButton: true,
                });
            }
        } catch (error) {
            console.error('Error al obtener rutas:', error);
            Swal.fire({
                title: 'Error',
                text: `Error: ${error.message}`,
                icon: 'error',
                showConfirmButton: true,
            });
        }

    }

    const getDispositivosByTipoServicio = async (idTipoServicio) => {
        let data = {
            "tipoequipo": idTipoServicio
        }
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_SERVER}/contratos/getlistadispositivosdisponibles`, JSON.stringify(data),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                }
            );

            if (res.data.success) {
                console.log('Dispositivos:', res.data.data);
                setDispositivos(res.data.data);
                setFilteredDispositivos(res.data.data);
            } else {
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo obtener la información, error de conexión',
                    icon: 'error',
                    showConfirmButton: true,
                });
            }
        } catch (error) {
            console.error('Error al obtener dispositivos:', error);
            Swal.fire({
                title: 'Error',
                text: `Error: ${error.message}`,
                icon: 'error',
                showConfirmButton: true,
            });
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            if (refs.fechaHoraCita.current) {
                const now = new Date();

                $.datetimepicker.setLocale('en');
                $(refs.fechaHoraCita.current).datetimepicker({
                    format: 'Y-m-d H:i',
                    step: 30,
                    value: now.toISOString().slice(0, 16).replace('T', ' '), // Fecha/hora inicial
                    timepicker: true,
                    datepicker: true,
                    maxDate: now, // Establece la fecha máxima permitida como la actual
                    onChangeDateTime: (dp, $input) => {
                        const selectedDate = new Date($input.val());
                        if (selectedDate > now) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Fecha inválida',
                                text: 'La fecha/hora seleccionada no puede ser mayor a la actual.',
                                confirmButtonColor: '#006699',
                            });
                            $input.val(''); // Limpia el campo si la fecha/hora es inválida
                            setDates((prevState) => ({
                                ...prevState,
                                fechaHoraCita: '', // Resetea el estado
                            }));
                        } else {
                            setDates((prevState) => ({
                                ...prevState,
                                fechaHoraCita: $input.val(), // Actualiza el estado con la fecha válida
                            }));
                        }
                    },
                });
            }
        }, 100); // Retraso para asegurar que el DOM esté completamente cargado

        return () => {
            if (refs.fechaHoraCita.current) {
                $(refs.fechaHoraCita.current).datetimepicker('destroy');
            }
            clearTimeout(timer);
        };
    }, [refs.fechaHoraCita]);


    useEffect(() => {
        getTypeServices();
        getRutas();
    }, []);

    // useEffect(() => {
    //     if (selectedTipoServicio) {
    //         // console.log('ID Tipo Servicio:', selectedTipoServicio);
    //     }
    // }, [selectedTipoServicio]);

    // useEffect(() => {
    //     if (selectedDispositivos.length > 0) {
    //         // console.log('Dispositivos:', selectedDispositivos);
    //     }
    // }, [selectedDispositivos]);

    return (
        <>


            <form className="crear-contrato-form">
                {/* Select para Tipo Servicios */}
                <div className="crear-contrato-field">
                    <label htmlFor="pedido">
                        Tipo Servicios:
                    </label>
                    <select
                        id="pedido"
                        value={selectedTipoServicio}
                        onChange={handleChange}
                        className="crear-contrato-control custom-select"
                    >
                        <option value="">Selecciona un tipo de servicio</option>
                        {tipoServicios && tipoServicios.map((tipoServicio) => (
                            <option key={tipoServicio.IDTipoServicios} value={tipoServicio.IDTipoServicios}>{tipoServicio.Descripcion}</option>
                        ))}
                    </select>
                </div>

                {/* Switch Buttons para dispositivos */}
                {dispositivos && dispositivos.length > 0 && (
                    <div
                        style={{
                            maxHeight: '200px',
                            overflowY: 'auto',
                            border: '1px solid #ccc',
                            padding: '8px',
                            borderRadius: '4px',
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                margin: "0 auto",
                                marginBottom: "10px",
                                position: 'sticky',
                                top: "-10px",
                                backgroundColor: "#fff", // Se recomienda para evitar transparencia durante el scroll
                                zIndex: 1,              // Para que el input esté por encima de otros elementos
                                padding: "8px"         // Opcional: para agregar espacio interno al contenedor sticky
                            }}
                        >
                            <Input
                                placeholder="Buscar en dispositivos..."
                                style={{ borderRadius: "10px" }}
                                onChange={(e) => handleDispositivosOnList(e)}
                            />
                        </div>
                        {filteredDispositivos.map((dispositivo) => (
                            <div key={dispositivo.DeviceID} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                <SwitchButton3
                                    checked={selectedDispositivos.includes(dispositivo.DeviceID)}
                                    onChange={(isActive) => handleSwitchChange(dispositivo.DeviceID, isActive)}
                                    type={
                                        selectedTipoServicio === 14 && dispositivo.UsuarioS
                                            ? `${dispositivo.DeviceID} (${dispositivo.UsuarioS})`
                                            : dispositivo.DeviceID
                                    }
                                    disabled={
                                        !selectedDispositivos.includes(dispositivo.DeviceID) &&
                                        selectedDispositivos.length >= 10
                                    }
                                />
                            </div>
                        ))}
                    </div>
                )}

                {/* Ubicacion */}
                <div className="crear-contrato-field">
                    <label htmlFor="ubicacion">
                        Referencia:
                    </label>
                    <input
                        type="text"
                        id="ubicacion"
                        value={Referencia}
                        onChange={(e) => setReferencia(e.target.value)}
                        className="crear-contrato-control"
                    />
                </div>
                {/* Contenedor */}
                <div className="crear-contrato-field">
                    <label htmlFor="contenedor">
                        Contenedor:
                    </label>
                    <input
                        type="text"
                        id="contenedor"
                        value={contenedor}
                        onChange={(e) => setContenedor(e.target.value)}
                        className="crear-contrato-control"
                    />
                </div>
                {/* Placa */}
                <div className="crear-contrato-field">
                    <label htmlFor="placa">
                        Placa:
                    </label>
                    <input
                        type="text"
                        id="placa"
                        value={placa}
                        onChange={(e) => setPlaca(e.target.value)}
                        className="crear-contrato-control"
                    />
                </div>

                <div className="crear-contrato-field">
                    <label htmlFor="rutas">
                        Rutas:
                    </label>
                    <select
                        className='crear-contrato-control custom-select'
                        id="rutas"
                        value={selectedRuta}
                        onChange={handleChangeRuta}
                    >
                        <option value="">Selecciona una ruta</option>
                        {rutas && rutas.map((ruta) => (
                            <option key={ruta.IdRuta} value={ruta.IdRuta}>{ruta.DescripcionRuta}</option>
                        ))}
                    </select>
                </div>

                {/* Botón Guardar */}
                <div className="crear-contrato-actions">
                    <button
                        type="button"
                        onClick={handleGuardar}
                        disabled={!selectedTipoServicio || selectedDispositivos.length === 0 || !placa || !contenedor || !selectedRuta || loading}
                        className="crear-contrato-submit"
                        style={{ backgroundColor: loading ? '#ccc' : undefined, cursor: loading ? 'not-allowed' : undefined }}
                    >
                        {loading ? (
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                                style={{ marginRight: '8px' }}
                            ></span>
                        ) : null}
                        Guardar
                    </button>

                </div>
            </form>
        </>
    );
};

export default CrearContrato3;
